/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantCatalogProductData
 */
export interface GoogleMerchantCatalogProductData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    identityKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    offerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    availability?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    priceMicros?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    priceCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    salePriceMicros?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductData
     */
    salePriceCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductData
     */
    issueCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductData
     */
    disapprovedDestinationCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantCatalogProductData
     */
    mapped?: boolean;
}

/**
 * Check if a given object implements the GoogleMerchantCatalogProductData interface.
 */
export function instanceOfGoogleMerchantCatalogProductData(value: object): value is GoogleMerchantCatalogProductData {
    return true;
}

export function GoogleMerchantCatalogProductDataFromJSON(json: any): GoogleMerchantCatalogProductData {
    return GoogleMerchantCatalogProductDataFromJSONTyped(json, false);
}

export function GoogleMerchantCatalogProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantCatalogProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'identityKey': json['identityKey'] == null ? undefined : json['identityKey'],
        'offerId': json['offerId'] == null ? undefined : json['offerId'],
        'title': json['title'] === undefined ? undefined : json['title'] === null ? null : json['title'],
        'brand': json['brand'] === undefined ? undefined : json['brand'] === null ? null : json['brand'],
        'availability': json['availability'] === undefined ? undefined : json['availability'] === null ? null : json['availability'],
        'link': json['link'] === undefined ? undefined : json['link'] === null ? null : json['link'],
        'priceMicros': json['priceMicros'] === undefined ? undefined : json['priceMicros'] === null ? null : json['priceMicros'],
        'priceCurrency': json['priceCurrency'] === undefined ? undefined : json['priceCurrency'] === null ? null : json['priceCurrency'],
        'salePriceMicros': json['salePriceMicros'] === undefined ? undefined : json['salePriceMicros'] === null ? null : json['salePriceMicros'],
        'salePriceCurrency': json['salePriceCurrency'] === undefined ? undefined : json['salePriceCurrency'] === null ? null : json['salePriceCurrency'],
        'issueCount': json['issueCount'] == null ? undefined : json['issueCount'],
        'disapprovedDestinationCount': json['disapprovedDestinationCount'] == null ? undefined : json['disapprovedDestinationCount'],
        'mapped': json['mapped'] == null ? undefined : json['mapped'],
    };
}

export function GoogleMerchantCatalogProductDataToJSON(json: any): GoogleMerchantCatalogProductData {
    return GoogleMerchantCatalogProductDataToJSONTyped(json, false);
}

export function GoogleMerchantCatalogProductDataToJSONTyped(value?: GoogleMerchantCatalogProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identityKey': value['identityKey'],
        'offerId': value['offerId'],
        'title': value['title'],
        'brand': value['brand'],
        'availability': value['availability'],
        'link': value['link'],
        'priceMicros': value['priceMicros'],
        'priceCurrency': value['priceCurrency'],
        'salePriceMicros': value['salePriceMicros'],
        'salePriceCurrency': value['salePriceCurrency'],
        'issueCount': value['issueCount'],
        'disapprovedDestinationCount': value['disapprovedDestinationCount'],
        'mapped': value['mapped'],
    };
}

